export default __webpack_public_path__ + "static/stream@2x-a047e9f6885f9ce377d8ab4695e6a9f1.png";